import React from "react";
import "./style.css";

const ToothOrRadiographTab = ({
  selectdTab = 0,
  onToothClick,
  onRadiographClick,
}) => {
  return (
    <div className="tooth_radio_graph_tab_container">
      <div className="tooth_radio_graph_tab_body">
        <div
          onClick={onToothClick}
          className="tooth_radio_graph_tab"
          style={{ background: selectdTab === 0 ? "white" : "transparent" }}
        >
          <p style={{ opacity: selectdTab === 1 ? 0.6 : 1 }}>Tooth Selection</p>
        </div>
        <div
          onClick={onRadiographClick}
          className="tooth_radio_graph_tab"
          style={{ background: selectdTab === 1 ? "white" : "transparent" }}
        >
          <p style={{ opacity: selectdTab === 0 ? 0.6 : 1 }}>
            Radiographic Review
          </p>
        </div>
      </div>
    </div>
  );
};

export default ToothOrRadiographTab;
